const HOME = "/";
const LOGIN = "/login";
const SIGNUP = "/register";
const SIGNUPORG = "/register/org";
const SIGNUPDRIVER = "/register/driver";
const LOADS = "/loads";
const LOAD_DETAILS = "load/:loadId";
const ADD_LOAD = "/single-load";
const PROFILE = "/profile";
const MANAGE_USERS = "/manage-users";
const GROUPS = "/groups";
const TEAMS = "/teams";
const BROKER_PAYMENTS = "/accounting/broker-payments";
const DRIVER_PAYMENTS = "/accounting/driver-payments";
const INVOICES = "/accounting/invoices";
const REPORTS = "/reports";
const CUSTOMERS = "/customers";
const CARRIERS = "/carriers";
const SETTINGS = "/settings";
const INACTIVE_ACCOUNT = "/inactive-account";
const DEPARTMENTS = "/departments";
const ASSETS = "/assets";
const ASSETS_MAP = "/assets-map";
const ASSETS_MAP_Extend = "/assets-map-extend";
const ASSETS_LEAFLET_MAP = "/assets-map";
const TRACK = "/track";
const TRACKING = "/tracking";
const ACCESS_MANAGEMENT = "branch/:branchId";
const TEAM_LIST = "/team-list";
const UPCOMING = "/upcoming";
const ORGANIZATIONS = "/organizations";
const FORGOT_PASS = "/forgot-password";
const RESET_PASS = "/reset-password";

const ROUTES = {
	PATHS: {
		HOME,
		LOGIN,
		SIGNUP,
		SIGNUPORG,
		SIGNUPDRIVER,
		LOADS,
		PROFILE,
		LOAD_DETAILS,
		MANAGE_USERS,
		GROUPS,
		TEAMS,
		INACTIVE_ACCOUNT,
		BROKER_PAYMENTS,
		DRIVER_PAYMENTS,
		INVOICES,
		REPORTS,
		CUSTOMERS,
		CARRIERS,
		SETTINGS,
		DEPARTMENTS,
		ASSETS,
		ASSETS_MAP,
		ASSETS_MAP_Extend,
		ASSETS_LEAFLET_MAP,
		ADD_LOAD,
		TRACK,
		ACCESS_MANAGEMENT,
		TEAM_LIST,
		TRACKING,
		UPCOMING,
		ORGANIZATIONS,
		FORGOT_PASS,
		RESET_PASS,
	},
};

export default ROUTES;
